export class StandardBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<StandardBackupSchedules>",
            "format": ""
        },
        {
            "name": "scheduleTimezone",
            "baseName": "scheduleTimezone",
            "type": "ScheduleTimezone",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StandardBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
